// version 1.0.6
// release 25.03.2025
import DateFormat from './DateFormat';
import Sys from './SystemUtils';

console.log('---init globals:');

global.runtime = window.require? 'node' : 'web';

global.store = {};			//global data storrage

global.system = Sys.logSystem();



//----------------------------------------------------------------------------- disable browser zoom
global.browserZoomDisabled = true

document.addEventListener("keydown", function (e) {
	if (global.browserZoomDisabled && e.ctrlKey && (e.key === '-' || e.key === '+')){
		e.preventDefault();
	}
});

document.addEventListener("wheel", e => {
	if (global.browserZoomDisabled && e.ctrlKey) {
		e.preventDefault();
	}}, {passive: false}
);



//----------------------------------------------------------------------------- wait
global.wait = async (sec=3) => {
	await new Promise(r => setTimeout(r, sec * 1000));	//wait n sec
}


//----------------------------------------------------------------------------- info
console.info = (...val) => {	//colorized log output
	console.log('%c ' + (typeof val[0] === 'string'? val.shift() : '...'), 'color:#8b0', ...val);
}

// fixedEncodeURIComponent:
// https://stackoverflow.com/questions/75980/when-are-you-supposed-to-use-escape-instead-of-encodeuri-encodeuricomponent
// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
global.encodeURI = str => {
	return str.replace(/[!'()* ]/g, c => {
		return '%' + c.charCodeAt(0).toString(16);
	});
}


//----------------------------------------------------------------------------- currencyFormat
global.currencyFormat = amount => {
	let str = Intl.NumberFormat('de-DE', {minimumFractionDigits:2, maximumFractionDigits:2}).format(amount);
	let p = str.split(',');
	if (p[1] && p[1] === '00') str = p[0] + ',-';
	return str;
}


//----------------------------------------------------------------------------- setFullscreen
global.setFullscreen = async on => {
	let elem = document.documentElement;
	let isOn = document.fullscreenElement !== null;

	if (on !== undefined && ((on && isOn) || (!on && !isOn))) return;

	if (isOn){
		if (document.exitFullscreen) await document.exitFullscreen();
		else if (document.mozCancelFullScreen) await document.mozCancelFullScreen();
		else if (document.webkitExitFullscreen) await document.webkitExitFullscreen();
		else if (document.msExitFullscreen) await document.msExitFullscreen();
	}else{
		if (elem.requestFullscreen)	await elem.requestFullscreen();
		else if (elem.mozRequestFullScreen) await elem.mozRequestFullScreen();		// Firefox
		else if (elem.webkitRequestFullscreen) await elem.webkitRequestFullscreen();	// Chrome, Safari & Opera
		else if (elem.msRequestFullscreen) await elem.msRequestFullscreen();			// IE/Edge
	}
}


//----------------------------------------------------------------------------- getUrlVars
global.getUrlVars = function(){
	let urlVars = {};
	// window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m,key,value) => {vars[key] = value});
	window.location.search.substring(1).split('&').forEach(param => {
		const [key, value] = param.split('=').map(decodeURIComponent);
		if (key) urlVars[key] = value;
	});
	console.log('---urlVars:', urlVars);
	return urlVars;
}
global.urlVars = global.getUrlVars();


//----------------------------------------------------------------------------- isMobile
global.isMobile = (device) => {		//https://www.abeautifulsite.net/detecting-mobile-devices-with-javascript
	switch(device){
		case 'android'		: return navigator.userAgent.match(/Android/i) !== null;
		case 'blackberry'	: return navigator.userAgent.match(/BlackBerry/i) !== null;
		case 'ios'			: return navigator.userAgent.match(/iPhone|iPad|iPod/i) !== null;
		case 'opera'		: return navigator.userAgent.match(/Opera Mini/i) !== null;
		case 'windows'		: return navigator.userAgent.match(/IEMobile/i) !== null;
		default				: return navigator.userAgent.match(/Mobile/i) !== null;
	}
}


//----------------------------------------------------------------------------- isOS
global.isOS = (os) => {
	switch(os){
		case 'windows'		: return navigator.userAgent.match(/Windows/i) !== null;
		case 'linux'		: return navigator.userAgent.match(/Linux/i) !== null;
		default:
	}
}



//----------------------------------------------------------------------------- onTimer
let timer;
let timerEvents = [];
let _events = {};
let timerCounter = 0;


//----------------------------------------------------------------------------- getTimeFormat
global.getTimeFormat = (format='dd.mm.yyyy HH:MM:ss') => {
	return DateFormat(format);
}


//----------------------------------------------------------------------------- onTimer
global.onTimer = (event) => {
	if (!timer) setTimer();
	if (!event) return null;

	let id = ++timerCounter;
	timerEvents.push(event);
	_events[id] = event;
	console.log('* add timer', id);
	return id;
}

//----------------------------------------------------------------------------- setTimer
const setTimer = e => {
	let d = new Date();
	let ms = 1000 - d.getMilliseconds();
	if (ms < 100) ms += 1000;		//take one second more if current ms < 100
	timer = setTimeout(e => {
		timerEvents.forEach(e => e());
		setTimer();
	}, ms);
}


//----------------------------------------------------------------------------- clearTimer
global.clearTimer = (id) => {			//clear all timer event if !id
	if (_events[id]){
		console.log('* clear timer', id);
		timerEvents.splice(timerEvents.indexOf(_events[id]), 1);
		delete _events[id];
	}
	if (!id || !timerEvents.length){	//no more timer events
		timerEvents = [];
		_events = {};
		// if (timer) clearInterval(timer);
		if (timer) clearTimeout(timer);
		timer = null;
	}
}


//----------------------------------------------------------------------------- onTimeout
global.onTimeout = (timeoutInSeconds, timeEvent, completeEvent) => {
	if (timeoutInSeconds === 0) return completeEvent? completeEvent() : null;

	let time = timeoutInSeconds;
	if (timeEvent) timeEvent(time);

	let t = global.onTimer(e => {
		time --;
		if (timeEvent) timeEvent(time);
		if (time <= 0){					//timeout reached
			if (completeEvent) completeEvent();
			global.clearTimer(t);		//remove this timer event
		}
	});
	
	return t;
}


//----------------------------------------------------------------------------- hideCursor
global.hideCursor = (delay) => {
	// document.getElementsByTagName('app');
}



//----------------------------------------------------------------------------- onKey
global.onKey = (key, event) => {
	console.log('onKey', key, event);
	//
}



//----------------------------------------------------------------------------- onResize observer handler
const onResize_elements = {};

global.onResize = (target, event) => {
	if (!target) return;

	if (!global.resizeObserver){
		global.resizeObserver = new ResizeObserver(entries => {
			entries.forEach(e => {
				if (onResize_elements[e.target]){
					onResize_elements[e.target](e.contentRect);
				}else{
					delete onResize_elements[target];
					global.resizeObserver.unobserve(target);
				}
			});
		});
	}

	if (onResize_elements[target]){		//element already registered
		if (!event){					//remove observer for this target
			delete onResize_elements[target];
			global.resizeObserver.unobserve(target);

		} else {
			return;
		};

	}else if (event){
		onResize_elements[target] = event;
		global.resizeObserver.observe(target);
	}
}


//----------------------------------------------------------------------------- onWindowResize
// const onWindowResize_elements = {};

// global.onWindowResize = (event) => {
// 	if (!global.onresize) global.onresize = e => {
// 		//
// 	}
// 	//
// }
